import { uniqueId } from 'lodash-es'
import { action, computed, observable } from 'mobx'
import type { SupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'

/**
 * Section of items.
 */
export class TaxInfoGatheringPageSectionViewModel {
  /**
   * Unique key for the section.
   */
  readonly key = uniqueId('section-')

  /**
   * Whether the section is expanded.
   */
  @observable accessor isExpanded = true

  constructor(
    private readonly _title: () => string,
    private readonly _items: () => SupportingItemViewModel[],
  ) {}

  /**
   * The title.
   */
  @computed get title() {
    return this._title()
  }

  /**
   * The sections.
   */
  @computed get isEmpty() {
    return this.items.length === 0
  }

  /**
   * The items in the section.
   */
  @computed get items() {
    return this._items()
  }

  /**
   * Get the incomplete and total counts.
   */
  @computed get counts() {
    let incomplete = 0
    let completed = 0
    let total = 0
    for (const item of this.items) {
      total++
      if (item.isCompleted) {
        completed++
      } else {
        incomplete++
      }
    }

    return { completed, incomplete, total } as const
  }

  /**
   * Toggles the expanded state.
   */
  @action.bound toggleExpanded() {
    this.isExpanded = !this.isExpanded
  }

  /**
   * Sets the expanded state.
   *
   * @param isExpanded
   */
  @action.bound setExpanded(isExpanded: boolean) {
    this.isExpanded = isExpanded
  }
}
